import { m as map_1 } from './map-8afd9017.js';

function customParametersUrlBuilder(urlAlias, customParameters) {
  if (urlAlias === undefined) {
    return urlAlias;
  }
  const hasQueryString = urlAlias.indexOf('?') !== -1;
  const hasIdSelector = urlAlias.indexOf('#') > -1;
  const suffix = hasQueryString ? '&' : '?';
  const queryString = map_1(customParameters, (value, key) => `${key}=${value}`).join('&');
  if (urlAlias.includes('mailto')) {
    return urlAlias;
  }
  if (hasIdSelector) {
    const startWithAnchor = urlAlias.startsWith('#');
    if (startWithAnchor) {
      return urlAlias;
    }
    const [alias, anchor] = urlAlias.split('#');
    return `${alias}${suffix}${queryString}#${anchor}`;
  }
  return queryString ? `${urlAlias}${suffix}${queryString}` : urlAlias;
}

export { customParametersUrlBuilder as c };
